module.exports = __webpack_public_path__ + "static/media/GenieMonde0.14162a25.mp3";